import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 346px;

  ${tokens.mediaQueries.s} {
    margin-bottom: ${tokens.space.looser};
  }
`;

export const Icon = styled.img`
  width: 141px;
  height: 141px;
  margin-bottom: ${tokens.space.large};

  ${tokens.mediaQueries.s} {
    width: 93px;
    height: 93px;
    margin-bottom: 0;
  }
`;

export const Title = styled.div`
  font-family: ${tokens.fonts.primary};
  font-weight: 500;
  font-size: 30px;
  line-height: 32px;
  text-align: center;
  color: ${tokens.colors.black};
  margin-bottom: ${tokens.space.regular};

  ${tokens.mediaQueries.s} {
    font-size: ${tokens.fontSizes.xl};
    margin-bottom: 0;
  }
`;

export const SubTitle = styled.div`
  font-family: ${tokens.fonts.primary};
  font-weight: 300;
  font-size: ${tokens.fontSizes.m};
  line-height: ${tokens.lineHeights.m};
  text-align: center;
  color: ${tokens.colors.grayDarkest};

  ${tokens.mediaQueries.s} {
    font-size: ${tokens.fontSizes.l};
  }
`;
